import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { ComponentContainer } from 'golden-layout';
import { EquipmentService } from '../../../_services/http/equipment.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import { loadEquipmentsAction, selectAllEquipments } from '../../../_store/EquipementStore/equipement.store';
import { Equipement, IEquipement } from '../../../_models/Equipment';
import { GridWrapper } from '../../../_models/GridWrapper';
import { GridComponent } from '@progress/kendo-angular-grid';
import { IZoomEvent } from '../../../_models/models';
import { ConfigService } from '../../../_services/local/config.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { distinct } from '@progress/kendo-data-query';

@Component({
  selector: 'app-widget-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.scss'],
})
export class EquipmentListComponent extends WidgetHostDirective implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  // Grid attributes
  public gridWrapper = new GridWrapper<Equipement>(
    'Equipment',
    this.store.select(selectAllEquipments),
    {
      logic: 'or',
      filters: [
        {
          field: 'nomSousSysteme',
          operator: 'contains',
        },
        {
          field: 'nom',
          operator: 'contains',
        },
        {
          field: 'localisation',
          operator: 'contains',
        },
      ],
    },
    this.kendoGrid
  );

  private channel = new BroadcastChannel('map-vec');

  constructor(
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>,
    public crudService: EquipmentService,
    private configService: ConfigService,
    private dashboardService: DashboardService
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);
  }

  ngOnInit(): void {
    this.gridWrapper.gridState.group = [
      {
        field: 'nomSousSysteme',
        dir: 'asc',
      },
    ];

    this.store.dispatch(loadEquipmentsAction());
    this.crudService.refreshHubConnection();
  }

  ngOnDestroy(): void {
    this.gridWrapper.destroy();
  }

  zoomTo(event: MouseEvent, equipment: IEquipement): void {
    event.stopPropagation();

    if (!this.configService.Config.layers) {
      return;
    }

    const data: IZoomEvent<IEquipement> = {
      type: 'zoom',
      title: 'Equipement',
      searchField: Equipement.SearchFieldForMap,
      searchText: equipment.idCartoEquipement,
      layerId: equipment.vecLayerId,
      subLayerIds: [equipment.vecSubLayerId],
    };

    if (this.dashboardService.isWidgetOpen('MapVecComponent')) {
      this.channel.postMessage(data);
      this.dashboardService.focusWidget('MapVecComponent');
    } else {
      this.dashboardService.openWidget('MapVecComponent', data);
    }
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.internalData, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }
}
